// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mongosh-shell-output-line-shell-output-line__DU1i6 {\n  padding: 0 8px;\n}\n.mongosh-shell-output-line-shell-output-line-error__-WUQq {\n  background-color: #f9d3c5;\n  color: #570b08;\n}\n.mongosh-shell-output-line-shell-output-line-error__-WUQq .mongosh-shell-output-line-shell-output-line-icon__6VSHv {\n  color: inherit;\n}\n.mongosh-shell-output-line-shell-output-line-icon__6VSHv {\n  color: #5d6c74;\n}\n", ""]);
// Exports
exports.locals = {
	"shell-output-line": "mongosh-shell-output-line-shell-output-line__DU1i6",
	"shell-output-line-error": "mongosh-shell-output-line-shell-output-line-error__-WUQq",
	"shell-output-line-icon": "mongosh-shell-output-line-shell-output-line-icon__6VSHv"
};
module.exports = exports;
